module.exports = __webpack_public_path__ + "img/mk.8fbf6ece.svg";